import React, { useEffect, useState } from 'react';

import axios from 'axios';

import numeral from 'numeral';
import moment from 'moment';

import { Row, Col, Form, Button, Modal } from 'react-bootstrap';

import {
    Container, CenteredTD, Header, HeaderActions, PrimaryButton, Panel, TableScroll, ListTable,
    StatusActions, FormActions, StyledTR, SideDrawer, SuccessToast,
} from '../ManageLayout';

import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const lastYear = moment()/* .subtract(1, 'y') */.year();

export default () => {
    const [costs, setCosts] = useState(null);

    const [showConfirmation, setShowConfirmation] = useState(false);

    // null = painel fechado; 'new' = novo custo; número = ano em edição
    const [editing, setEditing] = useState(null);
    const [ano, setAno] = useState(lastYear);
    const [value, setValue] = useState(0);
    const [yearOptions, setYearOptions] = useState([]);
    const [saving, setSaving] = useState(false);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    useEffect(() => {
        async function fetchCosts() {
            // TODO: TRY/CATCH

            let url = `${process.env.REACT_APP_SERVER}geo-service/manage/costs`;
            const { data: { rows } } = await axios.get(url);

            setCosts(rows);
        }

        fetchCosts();
    }, []);

    const refresh = async () => {
        const { data: { rows } } = await axios.get(`${process.env.REACT_APP_SERVER}geo-service/manage/costs`);
        setCosts(rows);
    }

    const doToast = (message) => {
        setToastMessage(message);
        setShowToast(true);
    }

    const startMng = (id) => {

        let yControl;
        if (id) {
            const current = costs.filter(({ ano }) => ano === id)[0];

            setValue(current.valor);

            yControl = getYearControl(current.ano);

        } else {
            setValue(0);
            yControl = getYearControl();
        }

        setYearOptions(yControl.options);
        setAno(yControl.selected);

        setEditing(id || 'new');
    }

    const handleRemove = async () => {
        setShowConfirmation(false);

        await axios.delete(`${process.env.REACT_APP_SERVER}geo-service/manage/costs/${editing}`);

        handleCloseMng();
        doToast('O custo foi removido!');
        refresh();
    }

    const handleCloseMng = () => {
        setEditing(null);
        setAno(lastYear);
        setValue(0);
    }

    const handleSave = async (e) => {
        e.preventDefault();

        setSaving(true);
        try {
            const floatValue = parseFloat(value);

            await axios.put(`${process.env.REACT_APP_SERVER}geo-service/manage/costs`, {
                ano,
                value: floatValue,
            });

            handleCloseMng();
            doToast('O custo foi gravado!');
            refresh();
        } catch (err) { }
        setSaving(false);
    }

    const getYearControl = (current) => {
        // lastYear até 2009, sem valores já adicionados, com valor atual (se houver)

        const options = [];

        const jaAdicionados = costs ? costs.map(prod => prod.ano) : [];
        for (let ano = 2009; ano <= lastYear; ano++) if (!jaAdicionados.includes(ano) || ano === current) options.push(ano);
        options.sort().reverse();

        let selected = options[0];
        if (current) selected = current;

        return {
            options: options,
            selected,
        };
    }

    const isEditing = editing !== null && editing !== 'new';

    return (
        <Container>
            <Header>
                <div>
                    <h4>Gestão de Custos</h4>
                    <small>Valor pago por quilo (R$/kg) em cada ano, usado para calcular o valor da produção</small>
                </div>
                <HeaderActions>
                    <PrimaryButton onClick={() => startMng()}>
                        <FontAwesomeIcon icon={faPlus} /> Novo custo
                    </PrimaryButton>
                </HeaderActions>
            </Header>

            <Panel>
                <TableScroll>
                    <ListTable>
                        <thead>
                            <tr>
                                <th>Ano</th>
                                <th className="number">Valor (R$/kg)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!costs && <tr><CenteredTD colSpan={2}>Carregando...</CenteredTD></tr>}
                            {!!costs && costs.length === 0 && <tr><CenteredTD colSpan={2}>Nenhum custo cadastrado!</CenteredTD></tr>}
                            {!!costs && costs.sort(perYear).map((row) => <StyledTR
                                key={row.ano}
                                className={`clickable ${row.ano === editing ? 'selected' : ''}`}
                                tabIndex={0}
                                onClick={() => startMng(row.ano)}
                                onKeyDown={(e) => { if (e.key === 'Enter') startMng(row.ano); }}
                            >
                                <td><span className="name">{row.ano}</span></td>
                                <td className="number">R$ {numeral(parseFloat(row.valor)).format('0,0.00')}</td>
                            </StyledTR>)}
                        </tbody>
                    </ListTable>
                </TableScroll>
            </Panel>

            {editing !== null && <SideDrawer title={isEditing ? `Custo de ${editing}` : 'Novo custo'} onClose={handleCloseMng}>
                {isEditing && <StatusActions>
                    <Button variant="outline-danger" size="sm" onClick={() => setShowConfirmation(true)}>
                        <FontAwesomeIcon icon={faTrashAlt} /> Remover
                    </Button>
                </StatusActions>}

                <Form onSubmit={handleSave}>
                    <Row>
                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Ano*</Form.Label>
                                {yearOptions.length > 0 && <Form.Control as="select" custom value={ano} disabled={isEditing} onChange={(e) => setAno(parseInt(e.target.value))}>
                                    {yearOptions.map(year => <option key={year} value={year}>{year}</option>)}
                                </Form.Control>}
                                {yearOptions.length === 0 && <div>Todos os anos foram preenchidos!</div>}
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group>
                                <Form.Label>Valor (R$/kg)*</Form.Label>
                                <Form.Control name="value" value={value} onChange={(e) => setValue(e.target.value)} />
                            </Form.Group>
                        </Col>
                    </Row>

                    <FormActions>
                        <Button variant="outline-secondary" onClick={handleCloseMng}>
                            Cancelar
                        </Button>
                        <PrimaryButton type="submit" disabled={saving || yearOptions.length === 0}>
                            {saving ? 'Gravando...' : (isEditing ? 'Salvar alterações' : 'Cadastrar custo')}
                        </PrimaryButton>
                    </FormActions>
                </Form>
            </SideDrawer>}

            <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmação de Remoção</Modal.Title>
                </Modal.Header>
                <Modal.Body>Você confirma a exclusão deste dado!?</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-dark" onClick={() => setShowConfirmation(false)}>
                        Cancelar
                    </Button>
                    <Button variant="dark" onClick={handleRemove}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            <SuccessToast show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
        </Container>
    );
}

function perYear(a, b) {
    if (a.ano > b.ano) return -1;
}
